<template>
  <div class="loginBody">
    <div style="text-align: left; margin-top: 14px; margin-left: 24px">
      <img src="/logo.png" alt="">
      <span style="font-weight: 700; color: white; font-size: 14px"> TP-LINK 实名认证中心 </span>
    </div>
    <login-page v-if="!resetPass" :app-type="appType" @submit="handleLogin" @reset="resetPass=true" />
    <reset v-else :app-type="appType" @submit="handleReset" @back="resetPass=false"/>
  </div>
</template>

<script>
import Config from "@/config"
import { setToken } from "@/utils/auth"
import { notify, getAppType } from "@/utils/util"
import { login, reset } from "@/api/login"
import { getCertificationInfo } from "@/api/certify"
import Reset from "./reset"
import LoginPage from "./loginPage"

const LOGIN_MSG = "登录成功啦！"
const RESET_MSG = "重置成功啦！"

export default {
  name: "Login",
  components: { LoginPage, Reset },
  data () {
    return {
      appType: "",
      resetPass: false,
    }
  },
  mounted () {
    this.appType = getAppType()
  },
  methods: {
    handleLogin (data, callback) {
      console.log("handleLogin", data)
      // 免登录测试，进入认证页面
      // this.$router.replace("/")
      // localStorage.setItem("accountName", data.accountName)
      // 调用登录接口
      const rememberMe = data.rememberMe
      delete data.rememberMe
      login(data).then((response) => {
        this.loading = false
        data.rememberMe = rememberMe
        console.log("login", response)
        if (response.error_code === 0) {
          setToken(response.result.token, data.rememberMe)
          localStorage.setItem("accountName", data.accountName)
          notify(Config.notifySuc, LOGIN_MSG)
          callback(true)

          const params = { accountName: data.accountName }
          getCertificationInfo(params).then((res) => {
            console.log("getCertificationInfo", res)
            if (res.error_code === 0 && res.result.status === 1) {
              this.$router.replace("/result")
            } else {
              this.$router.replace("/")
            }
          }).catch((error) => {
            console.log(error)
            notify(Config.notifyErr, Config.serverErrorMsg)
            callback(false)
          })
        } else {
          notify(Config.notifyErr, Config.errorMsg[response.error_code])
          callback(false)
        }
      }).catch((error) => {
        console.log(error)
        notify(Config.notifyErr, Config.serverErrorMsg)
        callback(false)
      })
    },
    handleReset (data, callback) {
      console.log("handleReset", data)
      reset(data).then((response) => {
        this.loading = false
        console.log("reset", response)
        if (response.error_code === 0) {
          this.resetPass = false
          notify(Config.notifySuc, RESET_MSG)
          callback(true)
        } else {
          notify(Config.notifyErr, Config.errorMsg[response.error_code])
          callback(false)
        }
      }).catch((error) => {
        console.log(error)
        notify(Config.notifyErr, Config.serverErrorMsg)
        callback(false)
      })
    },
  },
}
</script>

<style scoped>
.loginBody {
  width: 100%;
  height: 100%;
  overflow: auto;
  background: url("/login.png") no-repeat 100%;
  background-size: cover;
  position: fixed;
  line-height: 100%;
}
</style>